(function () {
  function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function initScarcityViewers(el) {
    if (el.getAttribute('data-scarcity-initialized') === 'true') return;
    el.setAttribute('data-scarcity-initialized', 'true');

    var min = parseInt(el.getAttribute('data-min'), 10) || 1;
    var max = parseInt(el.getAttribute('data-max'), 10) || min;
    if (max < min) max = min;

    var countEl = el.querySelector('[data-scarcity-viewers-count]');
    if (!countEl) return;

    var current = randomInt(min, max);
    countEl.textContent = current;

    function tick() {
      var delta = randomInt(-2, 2);
      current = Math.min(max, Math.max(min, current + delta));
      countEl.textContent = current;
      window.setTimeout(tick, randomInt(6000, 14000));
    }

    window.setTimeout(tick, randomInt(6000, 14000));
  }

  function initAll(scope) {
    var scopeEl = scope || document;
    var nodes = scopeEl.querySelectorAll ? scopeEl.querySelectorAll('[data-scarcity-viewers]') : [];
    Array.prototype.slice.call(nodes).forEach(initScarcityViewers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
